<h1>Colors</h1>
<p>
  We use a combination of neutrals and accents to bring about the right balance of color in our UI.
</p>
<div class="color-grid">
  <h2>Neutrals</h2>
  <!-- Neutrals -->
  @for (color of neutrals; track color) {
    <div class="color-box shadow-300" [style.background-color]="color.hex">
      <span class="tooltip">{{ color.name }}: {{ color.hex }}</span>
    </div>
  }

  <h2>Blues</h2>
  <!-- Blues -->
  @for (color of blues; track color) {
    <div class="color-box shadow-300" [style.background-color]="color.hex">
      <span class="tooltip">{{ color.name }}: {{ color.hex }}</span>
    </div>
  }

  <h2>Greens</h2>
  <!-- Greens -->
  @for (color of greens; track color) {
    <div class="color-box shadow-300" [style.background-color]="color.hex">
      <span class="tooltip">{{ color.name }}: {{ color.hex }}</span>
    </div>
  }

  <h2>Teals</h2>
  <!-- Teals -->
  @for (color of teals; track color) {
    <div class="color-box shadow-300" [style.background-color]="color.hex">
      <span class="tooltip">{{ color.name }}: {{ color.hex }}</span>
    </div>
  }

  <h2>Yellows</h2>
  <!-- Yellows -->
  @for (color of yellows; track color) {
    <div class="color-box shadow-300" [style.background-color]="color.hex">
      <span class="tooltip">{{ color.name }}: {{ color.hex }}</span>
    </div>
  }

  <h2>Oranges</h2>
  <!-- Oranges -->
  @for (color of oranges; track color) {
    <div class="color-box shadow-300" [style.background-color]="color.hex">
      <span class="tooltip">{{ color.name }}: {{ color.hex }}</span>
    </div>
  }

  <h2>Reds</h2>
  <!-- Reds -->
  @for (color of reds; track color) {
    <div class="color-box shadow-300" [style.background-color]="color.hex">
      <span class="tooltip">{{ color.name }}: {{ color.hex }}</span>
    </div>
  }

  <h2>Pinks</h2>
  <!-- Pinks -->
  @for (color of pinks; track color) {
    <div class="color-box shadow-300" [style.background-color]="color.hex">
      <span class="tooltip">{{ color.name }}: {{ color.hex }}</span>
    </div>
  }

  <h2>Purples</h2>
  <!-- Purples -->
  @for (color of purples; track color) {
    <div class="color-box shadow-300" [style.background-color]="color.hex">
      <span class="tooltip">{{ color.name }}: {{ color.hex }}</span>
    </div>
  }
</div>
